import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Nav, NavItem, Grid, Row, Col } from 'react-bootstrap'

import ProjectView from './components/ProjectView'
import DeliverableView from './components/DeliverableView'
import ProjectFilterContainer from './components/ProjectFilterContainer'
import InitialLoginModal from './components/InitialLoginModal'

import { getProjectsAndDeliverablesWithFilters, getProjectsWithFilters, getDeliverablesWithFilters } from './reducers/manageProjects'
import { changeProjectPage, changeProjectView, changeDeliverableView, changeDeliverablesPage } from './reducers/manageProjectFilters'

import { getClients, getUsers } from '../login/reducers/manageLogin'

import AuthenticationComponent from '../../AuthenticationComponent'

import './style.css'

class ProjectContainer extends Component {

  componentDidMount() {
    this.props.thisIsANewVariableToTestTheReduxPersistFix.forEach(x => console.log(x))
    let projectPageNumber = this.props.currentProjectPage
    let deliverablePageNumber = this.props.currentDeliverablesPage

    if (this.props.projects.length === 0) {
      projectPageNumber = 1
    }

    if (this.props.deliverables.length === 0) {
      deliverablePageNumber = 1
    }

    this.handleGetProjectsAndDeliverables(projectPageNumber, deliverablePageNumber)

    this.props.getClients()
    this.props.getUsers()
  }

  handleGetProjects = (pageNumber) => {
    this.props.changeProjectPage(pageNumber)
    this.props.getProjectsWithFilters(pageNumber, this.props)
    window.scrollTo(0, 0)
  }

  handleGetDeliverables = (page) => {
    this.props.changeDeliverablesPage(page)
    this.props.getDeliverablesWithFilters(page, this.props)
    window.scrollTo(0, 0)
  }

  handleGetProjectsAndDeliverables = (projectPage, deliverablesPage) => {
    this.props.changeProjectPage(projectPage)
    this.props.changeDeliverablesPage(deliverablesPage)
    this.props.getProjectsAndDeliverablesWithFilters(projectPage, deliverablesPage, this.props)
    window.scrollTo(0, 0)
  }


  componentDidUpdate(prevProps) {
    const {
      projectLeadFilter,
      analystFilter,
      clientFilter,
      statusFilter,
      regulatoryRelatedFilter,
      metadataFilters,

      myProjectsFilter,
      projectSortType,
      projectsHaveBeenSearched,
      projectNameFilter,
      projectRduidFilter,

      myDeliverablesFilter,
      deliverableStatusFilter,
      deliverableAssignedToFilter,
      deliverableSortType,
    } = this.props

    if (projectLeadFilter.length !== prevProps.projectLeadFilter.length ||
        analystFilter.length !== prevProps.analystFilter.length ||
        clientFilter.length !== prevProps.clientFilter.length ||
        statusFilter.length !== prevProps.statusFilter.length ||
        regulatoryRelatedFilter.length !== prevProps.regulatoryRelatedFilter.length ||
        metadataFilters.length !== prevProps.metadataFilters.length ||
        (projectRduidFilter && prevProps.projectRduidFilter && (projectRduidFilter.length !== prevProps.projectRduidFilter.length)) ||
        (projectsHaveBeenSearched && projectNameFilter.length === 0 && prevProps.projectNameFilter.length > 0)
      ) {
      this.handleGetProjectsAndDeliverables(1, 1, this.props)
    } else if (myProjectsFilter !== prevProps.myProjectsFilter ||
      projectSortType !== prevProps.projectSortType
    ) {
      this.handleGetProjects(1)
    } else if (myDeliverablesFilter !== prevProps.myDeliverablesFilter ||
        deliverableStatusFilter !== prevProps.deliverableStatusFilter ||
        deliverableAssignedToFilter !== prevProps.deliverableAssignedToFilter ||
        deliverableSortType !== prevProps.deliverableSortType
    ) {
      this.handleGetDeliverables(1)
    }
  }

  render() {
    return (
      <div id="ProjectContainer">
        <AuthenticationComponent />
        <InitialLoginModal />
        <Grid>
          <Row>

            <Col xs={12} md={3}>
              <ProjectFilterContainer history={this.props.history} />
            </Col>

            <Col xs={12} sm={12} md={9} lg={9}>
              {this.props.fetchingProjects || this.props.fetchingDeliverables ?
                <div id="not-found">
                  <img alt="loader" src={require("../../static/images/spinner.gif")} />
                </div>
                :
                <Fragment>
                  <Nav
                    bsStyle="tabs"
                    activeKey={ !this.props.deliverablesView ? "project-view" : "deliverable-view"}
                  >
                    <NavItem
                      eventKey="project-view"
                      title="project-view"
                      onClick={this.props.changeDeliverableView}
                    >
                      Project View
                    </NavItem>
                    <NavItem
                      eventKey="deliverable-view"
                      title="deliverable-view"
                      onClick={this.props.changeDeliverableView}
                    >
                      Deliverable View
                    </NavItem>
                  </Nav>

                  {this.props.deliverablesView ?
                    <DeliverableView
                      history={this.props.history}
                      handleGetDeliverables={this.handleGetDeliverables}
                    />
                    :
                    <ProjectView
                      history={this.props.history}
                      handleGetProjects={this.handleGetProjects}
                    />
                  }

                </Fragment>
              }
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetchingProjects: state.manageProjects.fetchingProjects,
    fetchingDeliverables: state.manageProjects.fetchingDeliverables,
    projects: state.manageProjects.projects,
    deliverables: state.manageProjects.deliverables,
    projectCount: state.manageProjects.projectCount,
    projectResultsPerPage: state.manageProjects.projectResultsPerPage,
    projectLeadFilter: state.manageProjectFilters.projectLeads,
    analystFilter: state.manageProjectFilters.analysts,
    projectNameFilter: state.manageProjectFilters.projectName,
    projectRduidFilter: state.manageProjectFilters.projectRduids,
    statusFilter: state.manageProjectFilters.status,
    regulatoryRelatedFilter: state.manageProjectFilters.regulatoryRelated,
    metadataFilters: state.manageProjectFilters.metadataFilters,
    currentProjectPage: state.manageProjectFilters.currentProjectPage,
    currentDeliverablesPage: state.manageProjectFilters.currentDeliverablesPage,
    projectsPerPage: state.manageProjectFilters.projectsPerPage,
    currentUser: state.manageLogin.user,
    projectSortType: state.manageProjectFilters.projectSortType,
    deliverablesView: state.manageProjectFilters.deliverablesView,
    clientFilter: state.manageProjectFilters.clients,
    myProjectsFilter: state.manageProjectFilters.myProjectsFilter,
    projectsHaveBeenSearched: state.manageProjectFilters.projectsHaveBeenSearched,
    thisIsANewVariableToTestTheReduxPersistFix: state.manageProjects.thisIsANewVariableToTestTheReduxPersistFix,

    myDeliverablesFilter: state.manageProjectFilters.myDeliverablesFilter,
    deliverableStatusFilter: state.manageProjectFilters.deliverableStatusFilter,
    deliverableAssignedToFilter: state.manageProjectFilters.deliverableAssignedToFilter,
    deliverableSearchTerm: state.manageProjectFilters.deliverableSearchTerm,
    deliverableSortType: state.manageProjectFilters.deliverableSortType,

    clients: state.manageLogin.clients,
    users: state.manageLogin.users,

    projectsCancelToken: state.manageProjects.projectsCancelToken,
    deliverablesCancelToken: state.manageProjects.deliverablesCancelToken,
  }
}

export default connect(mapStateToProps, { getProjectsAndDeliverablesWithFilters, getProjectsWithFilters, getDeliverablesWithFilters, changeProjectPage, changeProjectView, changeDeliverableView, changeDeliverablesPage, getClients, getUsers })(ProjectContainer);



// WEBPACK FOOTER //
// ./src/routes/projects/ProjectContainer.js